import React from 'react';

const ConfirmDialog = ({ message, onConfirm, onCancel, confirmText = 'Confirm', confirmColor = '#DC2626', icon = '⚠' }) => (
  <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:999999,display:'flex',alignItems:'center',justifyContent:'center'}}>
    <div style={{background:'white',borderRadius:'12px',padding:'28px',maxWidth:'420px',width:'90%',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
      <div style={{fontSize:'36px',textAlign:'center',marginBottom:'12px'}}>{icon}</div>
      <div style={{fontSize:'15px',color:'#374151',textAlign:'center',marginBottom:'24px',lineHeight:'1.5'}}>{message}</div>
      <div style={{display:'flex',gap:'10px',justifyContent:'center'}}>
        <button onClick={onCancel} style={{padding:'10px 24px',border:'1px solid #D1D5DB',borderRadius:'7px',background:'white',color:'#6B7280',cursor:'pointer',fontWeight:'600',fontSize:'14px'}}>Cancel</button>
        <button onClick={onConfirm} style={{padding:'10px 24px',border:'none',borderRadius:'7px',background:confirmColor,color:'white',cursor:'pointer',fontWeight:'700',fontSize:'14px'}}>{confirmText}</button>
      </div>
    </div>
  </div>
);

export default ConfirmDialog;
